import { SendRequest } from './../../../../core/store/general/actions';
import { AuthService } from './../../../../core/services/auth.service';
import { SharedContainer } from './../../../shared.container';
import {Component, OnInit, ViewChild, Output, EventEmitter, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import {LoginFormComponent} from './login-form/login-form.component';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

/**
* View that allows user login
*/
@Component({
  selector: 'app-login-view',
  templateUrl: './login-view.component.html',
  styleUrls: ['./login-view.component.css'],
})
export class LoginViewComponent implements OnInit {

  public loginModal;
  public registerModal;

  public show = false;
  loginVisible = true;
  options = {backdrop: false};
  @Output() modalClosed: EventEmitter<any> = new EventEmitter();

 // public logButton: any = 'Show';
  @ViewChild(LoginFormComponent, { static: true }) guaranteeForm: LoginFormComponent;
  // @ViewChild('loginModal') loginRegisterModal: ElementRef;
  @ViewChild('loginModal', { static: true }) public childModal: ModalDirective;
  // @ViewChild('loginModal') childModal: LoginViewComponent;

  constructor(private router: Router,
              protected sharedContainer: SharedContainer,
              private auth: AuthService,
              private modalService: NgbModal, private elementRef: ElementRef
            ) {
  }

  ngOnInit() {
    // this.router.navigate([''])
    this.sharedContainer.generalState$.dispatch(new SendRequest(1,
      {isRequestSendEnabled: true}));
  }

  onResult(user) {
    this.sharedContainer.login(user.email, user.passwd);
    this.toggle();
    this.hide();

    if (this.isMobile()) { this.closeModal(true); }
  }

  onChangePassword(user) {
    this.auth.forgotPassword(user.email, user.passwd).subscribe((result) => console.log(result),
      (error) => alert(error.error));
    /*this.toggle();
    this.hide();

    if (this.isMobile()) { this.closeModal(true); }*/
  }
  onSignup(user) {
    this.sharedContainer.register(user);
    this.toggle();
    this.hide();
    if (this.isMobile()) { this.closeModal(true); }
  }

  toggle() {
    this.show = !this.show;
  }

  isMobile() {
    const width = window.innerWidth;
    if (width < 769) {
      return true;
    }
    return false;
  }

  showModal(isSignIn) {
    this.loginVisible = isSignIn;
    console.log(this.childModal);
    const width = window.innerWidth;
    console.log(width);
    if (width < 769) {
      document.getElementById('mobile-form').style.width = '100%';
    } else {
      this.childModal.show();
    }
  }

  isOpen() {
    return this.show;
  }

  hide() {
    this.childModal.hide();
    this.modalClosed.emit(true);
  }

  closeModal(data) {
    const width = window.innerWidth;
    if (width < 769) {
      document.getElementById('mobile-form').style.width = '0';
    } else {
      this.hide();
    }

    document.getElementById('total-book').style.visibility = 'visible';
  }

  socialLogin(social) {
    this.sharedContainer.socialLogin(social);
    if (this.isMobile()) { this.closeModal(true); }
  }

}
